var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSort24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.618 7.245c0-.506.41-.917.917-.917h10.083a.917.917 0 010 1.834H10.535a.917.917 0 01-.917-.917zm0-3.667c0-.506.41-.916.917-.916h11.917a.917.917 0 110 1.833H10.535a.917.917 0 01-.917-.917zm0 7.333c0-.506.41-.916.917-.916h7.333a.917.917 0 010 1.833h-7.333a.917.917 0 01-.917-.917zm0 3.667c0-.506.41-.917.917-.917h4.583a.917.917 0 010 1.834h-4.583a.917.917 0 01-.917-.917z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.696 22.598a.687.687 0 01-.972 0l-4.125-4.125a.687.687 0 01.486-1.174h3.208V2.117a.917.917 0 011.834 0V17.3h3.208a.688.688 0 01.486 1.174l-4.125 4.125z",
    clipRule: "evenodd"
  })));
}
export default SvgIconSort24;